module.exports = __webpack_public_path__ + "static/STG20_Mobile_960_Module4_BottomImage-ecdf207ad1f6717875c5cf120b12f61d.jpg";